module.exports = __webpack_public_path__ + "static/media/purchase-succeeded.b554c13d.png";